<template>
    <div class="noticeBack" @click="closeModal()">
        <div class="notice" @click.stop>
            <img src="@/assets/icons/exit.svg" @click="closeModal()" class="exit">
            <div class="notice__top">
                <p class="notice__top__title">Центр уведомлений</p>
                <div class="notice__top__count">5</div>
            </div>
            <div class="line"></div>
            <div class="notice__block">
                <div class="notice__block__in" v-for="item in 4" :key="item">
                    <div class="notice__block__in__top">
                        <img src="@/assets/icons/person.svg"/>
                        <div class="notice__block__in__top__info">
                            <div class="notice__block__in__top__info__top">
                                <p class=notice__block__in__top__info__top__name>Кейт М.</p>
                                <p class=notice__block__in__top__info__top__status>добавлен(-а) в список клиентов</p>
                            </div>
                            <div class="notice__block__in__top__info__date">
                                Воскресенье, 17 Ноября 15:32
                            </div>
                        </div>
                    </div>
                    <div class="line">

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

export default {
  data() {
    return {
    };
  },
  methods: {
    closeModal(){
        this.$emit('closeModal')
    }
  }
};
</script>
<style lang="scss" scoped>
.exit{
    filter: brightness(0) saturate(100%) invert(66%) sepia(8%) saturate(11%) hue-rotate(12deg) brightness(95%) contrast(84%);
    width: min(max(14px, calc(0.875rem + ((1vw - 7.68px) * 0.5208))), 20px);
    height: min(max(14px, calc(0.875rem + ((1vw - 7.68px) * 0.5208))), 20px);
    position: absolute;
    top: min(max(18px, calc(1.125rem + ((1vw - 7.68px) * 1.0417))), 30px);
    right: min(max(24px, calc(1.5rem + ((1vw - 7.68px) * 1.3889))), 40px);
    cursor: pointer;
}
    .line{
        border-top: 1px solid #0000001A;
        width: 100%;
    }
    .notice{
        background-color: white;
        width: 35%;
        padding: min(max(18px, calc(1.125rem + ((1vw - 7.68px) * 1.0417))), 30px)min(max(24px, calc(1.5rem + ((1vw - 7.68px) * 1.3889))), 40px);
        display: flex;
        flex-direction: column;
        position: relative;
        gap: min(max(14px, calc(0.875rem + ((1vw - 7.68px) * 0.5208))), 20px);
        border-radius: min(max(14px, calc(0.875rem + ((1vw - 7.68px) * 0.5208))), 20px);
        &__top{
            display: flex;
            gap: min(max(10px, calc(0.625rem + ((1vw - 7.68px) * 0.434))), 15px);
            &__title{
                font-size: min(max(16px, calc(1rem + ((1vw - 7.68px) * 0.6944))), 24px);
                font-weight: 600;
                color: #11415D;
            }
            &__count{
                width: min(max(18px, calc(1.125rem + ((1vw - 7.68px) * 1.0417))), 30px);
                height: min(max(18px, calc(1.125rem + ((1vw - 7.68px) * 1.0417))), 30px);
                background: #F8F8F8;
                border: 1px solid #0000001A;
                border-radius: 8px;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #0000004D;
            }
        }
        &__block{
            display: flex;
            flex-direction: column;
            gap: min(max(15px, calc(0.9375rem + ((1vw - 7.68px) * 0.8681))), 25px);
            &__in{
                display: flex;
                flex-direction: column;
                gap: min(max(15px, calc(0.9375rem + ((1vw - 7.68px) * 0.8681))), 25px);
                &__top{
                    display: flex;
                    gap: min(max(14px, calc(0.875rem + ((1vw - 7.68px) * 0.5208))), 20px);
                    img{
                        width: 60px;
                        height: 60px;
                    }
                    &__info{
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                        height: auto;
                        &__top{
                            display: flex;
                            gap: 10px;
                            align-items: center;
                            &__status{
                                color: #0000008A;
                            }
                            &__name{
                                font-weight: 600;
                            }
                        }
                        &__date{
                            color: #0000008A;
                        }
                    }
                }
            }
        }
    }
</style>